import 'formdata-polyfill';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './assets/scss/styles.scss';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');

// Monkey patch performance.measure to swallow React 19 / react-scripts conflicts
const originalMeasure = performance.measure;
performance.measure = (name, startPromise, endMark) => {
    try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return originalMeasure.call(performance, name, startPromise, endMark);
    } catch (e) {
        console.warn("Swallowed performance.measure error:", e);
        return;
    }
};

// Suppress deprecated lifecycle warnings from external libraries
const originalConsoleError = console.error;
const originalConsoleWarn = console.warn;

const shouldSuppress = (args: any[]) => {
    // Convert all arguments to strings and check them
    const argsAsString = args.map(arg => String(arg)).join(' ');
    return (
        argsAsString.includes('componentWillMount') ||
        argsAsString.includes('componentWillReceiveProps') ||
        argsAsString.includes('UNSAFE_componentWillMount') ||
        argsAsString.includes('UNSAFE_componentWillReceiveProps') ||
        argsAsString.includes('go.apollo.dev/c/err') ||
        argsAsString.includes('An error occurred! For more details')
    );
};

console.error = (...args) => {
    if (shouldSuppress(args)) {
        return;
    }
    originalConsoleError.apply(console, args);
};

console.warn = (...args) => {
    if (shouldSuppress(args)) {
        return;
    }
    originalConsoleWarn.apply(console, args);
};

const root = createRoot(container!);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
